<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="exportar-cont">
      <app-exportar
        [data]="insuranceData"
        (exportar)="onExportar($event)"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="campos-cont">
    <app-campos
      [tipo]="'estadoCuentas'"
      [camposVisibles]="['corte', 'selectFilter', 'bolanteDePago']"
      [camposObligatorios]="['corte', 'selectFilter']"
      (filterChange)="onFilterChange($event)"
      [opcionesSelectFilter]="opcionesSelectFilter"
    ></app-campos>
  </div>
</div>

<app-insurance-table
  [itemsPerPage]="6"
  [data]="insuranceData"
  [config]="tableConfig"
  [mensajeNoData]="mensajeNoData"
  [error]="errorStatus"
></app-insurance-table>
